import * as Yup from 'yup';
import { TType } from '@translations/translationsTypes';

export const SurveyFormValidationScheme = (t: TType) => {
  return Yup.object()
    .shape({
      satisfactionLevelId: Yup.string().required(t('survey.required.error')),
      easeOfUseId: Yup.string().required(t('survey.required.error')),
      anyIssueId: Yup.string().required(t('survey.required.error')),
      issueDescription: Yup.string().when('anyIssueId', {
        is: (anyIssueId: string) => anyIssueId === 'YES',
        then: (scheme) =>
          scheme.required(t('survey.required.error')).max(500, t('survey.max.char.error')),
      }),
      comments: Yup.string().max(500, t('survey.max.char.error')),
    })
    .nullable();
};
